import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { formatDate } from "../../../../utils/date-converter";

const QuotationPDFInfo = ({ quotation, contact }) => {
  const renderAddressString = (addressValues) => {
    let result = "";

    if (Array.isArray(addressValues)) {
      addressValues.forEach((item) => {
        if (item.length > 0) {
          result = result + item + ", ";
        }
      });
    } else {
      const keys = Object.keys(addressValues);
      keys.forEach((key) => {
        if (addressValues[key].length > 0) {
          result = result + addressValues[key] + ", ";
        }
      });
    }
    if (result.trim().length === 0) {
      return "-";
    }
    // remove whitespace and last comma
    return result.trim().slice(0, -1);
  };

  const leftHeader = [
    "รหัสลูกค้า / Customer ID",
    "ชื่อลูกค้า / Customer Name",
    "ที่อยู่ / Address",
    "เลขผู้เสียภาษี / Tax ID",
    "เบอร์โทรศัพท์ / Phone",
    "แฟกซ์ / Fax",
    "อีเมล / Email",
  ];

  const leftInfo = [
    quotation?.contact_document_id || "-",
    contact?.contact_name || "-",
    renderAddressString(quotation?.customer?.billing_address || {}) || "",
    contact?.identity_no || "-",
    quotation?.customer?.phone || "-",
    quotation?.customer?.fax || "-",
    quotation?.customer?.email || "-",
  ];

  const rightHeader = [
    "เลขที่เอกสาร / Document No.",
    "พนักงานขาย / Salesperson",
    "วันที่ออกเอกสาร / Issue date",
    "ใช้ได้ถึง / Due Date",
    "เครดิต / Credit",
  ];

  const rightInfo = [
    quotation?.document_id || "-",
    quotation?.employee_list.length > 0
      ? quotation?.employee_list.map(
          (employee) => employee?.first_name + " " + employee?.last_name
        )[0]
      : "-",
    formatDate(quotation?.issue_date) || "-",
    formatDate(quotation?.due_date) || "-",
    quotation?.credit_day ? quotation?.credit_day + " วัน" : "-",
  ];

  return (
    <Grid container sx={{ my: 1 }}>
      <Grid item xs={6}>
        {leftHeader.map((name, index) => (
          <Box sx={{ display: "flex" }} key={index}>
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: "24px",
                letterSpacing: "0.15px",
                fontWeight: 600,
                color: "#333333",
                flex: 1,
              }}
            >
              {name}
            </Typography>
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: "24px",
                letterSpacing: "0.15px",
                flex: 1,
                width: "100%",
                wordBreak: "break-word",
              }}
            >
              {leftInfo[index]}
            </Typography>
          </Box>
        ))}
      </Grid>
      <Grid item xs={6}>
        {rightHeader.map((name, index) => (
          <Box sx={{ display: "flex" }} key={index}>
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: "24px",
                letterSpacing: "0.15px",
                fontWeight: 600,
                color: "#333333",
                flex: 1,
              }}
            >
              {name}
            </Typography>
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: "24px",
                letterSpacing: "0.15px",
                flex: 1,
                width: "100%",
                wordBreak: "break-word",
              }}
            >
              {rightInfo[index]}
            </Typography>
          </Box>
        ))}
      </Grid>
    </Grid>
  );
};

export default QuotationPDFInfo;
